export const rendaVariavelSell = '#D76662';
export const rendaVariavelBuy = '#3546C0';
